<template>
  <div v-if="showTableContent" :class="$style.container">
    <table :class="$style.table">
      <thead>
        <tr>
          <td>No</td>
          <td>Data Collection Period Criteria</td>
          <template
            v-if="
              samplingConfigurations.auditSamplingType === 'consecutive' &&
              samplingConfigurations.samplingMode === 'minAndMax'
            "
          >
            <td width="5%">Min</td>
            <td width="5%">Max</td>
          </template>
          <template
            v-else-if="
              samplingConfigurations.auditSamplingType === 'targetSampleSize' ||
              (samplingConfigurations.auditSamplingType === 'consecutive' &&
                samplingConfigurations.samplingMode === 'targetSample')
            "
          >
            <td width="5%">Target</td>
          </template>
          <template
            v-else-if="samplingConfigurations.auditSamplingType === 'adHoc'"
          >
            <td width="5%">Ad-Hoc</td>
          </template>
          <td width="15%">Total-To-Date</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="`dataCollection${index}`">
          <td>{{ index + 1 }}</td>
          <td>{{ item.criteria }}</td>
          <template
            v-if="
              samplingConfigurations.auditSamplingType === 'consecutive' &&
              samplingConfigurations.samplingMode === 'minAndMax'
            "
          >
            <td>{{ item.minSampleSize }}</td>
            <td>{{ item.maxSampleSize }}</td>
          </template>
          <template
            v-else-if="
              samplingConfigurations.auditSamplingType === 'targetSampleSize' ||
              (samplingConfigurations.auditSamplingType === 'consecutive' &&
                samplingConfigurations.samplingMode === 'targetSample')
            "
          >
            <td style="text-align: right">{{ item.targetSize }}</td>
          </template>
          <template
            v-else-if="samplingConfigurations.auditSamplingType === 'adHoc'"
          >
            <td style="text-align: right">
              {{ item.isSamplingEnabled ? 'Enabled' : 'Disabled' }}
            </td>
          </template>
          <td style="text-align: right">{{ item.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch, Model } from 'vue-property-decorator';
import { State, Getter, Action, Mutation, namespace } from 'vuex-class';
import {
  DataCollectionSummaryRequestPayload,
  DataCollectionSummaryResponsePayload,
} from '../../../store/modules/audits/types/audits.types';
import { get as _get } from 'lodash';

@Component({
  components: {},
})
export default class DataCollectionTable extends Vue {
  @Prop()
  public data!: any;

  @Prop()
  public samplingConfigurations!: any;

  public showTableContent: boolean = false;

  public mounted() {
    this.showTableContent = true;
  }
}
</script>

<style lang="scss" module>
.container {
  margin-bottom: 5rem;
}
.table {
  width: 100%;
  box-shadow: 0 2px 2px $grey-border;
  border: 0.5px solid $grey-border;

  thead {
    tr {
      // border-bottom: 1px solid $grey-border;

      td,
      th {
        padding: 1rem;
        color: $grey-light-2;
        font-weight: 500;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 1px solid $grey-border;
      &:hover {
        cursor: pointer;
        background-color: #f7fbff;
      }
      td,
      th {
        padding: 1.25rem 1rem;
      }
    }

    tr:last-child {
      border-bottom: none;
    }
  }

  tr > td:last-child {
    text-align: right;
  }
}
</style>
